import EventIcon from "icons/EventIcon";
import TimerIcon from "icons/TimerIcon";
import PenIcon from "icons/PenIcon";
import PieChartIcon from "icons/PieChartIcon";
import SettingIcon from "icons/SettingIcon";
import { RESOURCE_MODULE_IDS } from "./constants";

export const USER_ROLES = {
    SUPERADMIN: 1,
    EVENTOS_COORDINADOR: 31,
    EVENTOS_DOCENTE: 32,
    REF_ACAD_COORDINADOR: 33,
    REF_ACAD_TUTOR: 34,
    ASESORIAS_COORDINADOR: 35,
    ASESORIAS_PSICOLOGO: 36,
    RECURSOS_BIBLIOTECARIO: 19,
    RECURSOS_BIBLIOTECA_COORDINADOR: 37,
    RECURSOS_ESPACIOS_UNIVERSITARIOS_COORDINADOR_GENERAL: 39,
    RECURSOS_ESPACIOS_UNIVERSITARIOS_COORDINADOR_CAMPUS: 40,
    ASESORIAS_JEFECAMPUS:41,
    COORDINADOR_EVENTOS_ESPACIOS_UNIVERSITARIOS: 42
};
export const MODULE_VIEWS = {
    EVENTOS: 1, REF_ACAD: 2,
    ASESORIAS: 3, RECURSOS: 4,
    CONFIG: 5
};
export const PERMISSIONS_VIEWS = {
    EVENTOS: {
        CARGA_MANUAL: 26, CARGA_MASIVA: 27,
        LISTADO_EVENTOS: 28, ASISTENCIA: 29
    },
    REF_ACAD: {
        CARGA_MANUAL: 30, CARGA_MASIVA: 31,
        LISTADO_REF_ACAD: 32, ASISTENCIA: 33
    },
    ASESORIAS: {
        CREAR_ASESORIAS: 34, HORARIOS_ASESORIAS: 35
    },
    RECURSOS: {
        ESPACIOS_UNIVERSITARIOS: 38,
        BIBLIOTECA: 5,
        OTROS: 36
    },
    CONFIG: {
        ADMIN_ROLES: 39, ADMIN_ESPACIOS: 40,
        ADMIN_HORARIOS: 41, ADMIN_SANCIONES: 42,
        ADMIN_RECURSOS: 43
    }
};
export const ROLE_BY_PERMISSIONS = {
    [USER_ROLES.SUPERADMIN]: [
        PERMISSIONS_VIEWS.EVENTOS.LISTADO_EVENTOS,
        PERMISSIONS_VIEWS.EVENTOS.CARGA_MANUAL,
        PERMISSIONS_VIEWS.EVENTOS.CARGA_MASIVA,
        PERMISSIONS_VIEWS.EVENTOS.ASISTENCIA,
        PERMISSIONS_VIEWS.REF_ACAD.LISTADO_REF_ACAD,
        PERMISSIONS_VIEWS.REF_ACAD.CARGA_MANUAL,
        PERMISSIONS_VIEWS.REF_ACAD.CARGA_MASIVA,
        PERMISSIONS_VIEWS.REF_ACAD.ASISTENCIA,
        PERMISSIONS_VIEWS.ASESORIAS.CREAR_ASESORIAS,
        PERMISSIONS_VIEWS.ASESORIAS.HORARIOS_ASESORIAS,
        PERMISSIONS_VIEWS.RECURSOS.BIBLIOTECA,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_ROLES,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_HORARIOS,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_SANCIONES,
        PERMISSIONS_VIEWS.RECURSOS.ESPACIOS_UNIVERSITARIOS,
        PERMISSIONS_VIEWS.RECURSOS.OTROS,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_ESPACIOS,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_RECURSOS
    ],
    [USER_ROLES.EVENTOS_COORDINADOR]: [
        PERMISSIONS_VIEWS.EVENTOS.LISTADO_EVENTOS,
        PERMISSIONS_VIEWS.EVENTOS.CARGA_MANUAL,
        PERMISSIONS_VIEWS.EVENTOS.CARGA_MASIVA
    ],
    [USER_ROLES.EVENTOS_DOCENTE]: [
        PERMISSIONS_VIEWS.EVENTOS.LISTADO_EVENTOS,
        PERMISSIONS_VIEWS.EVENTOS.ASISTENCIA,
        // se habilita el permiso de refuerzo académico
        PERMISSIONS_VIEWS.REF_ACAD.LISTADO_REF_ACAD,
        PERMISSIONS_VIEWS.REF_ACAD.ASISTENCIA
    ],
    [USER_ROLES.REF_ACAD_COORDINADOR]: [
        PERMISSIONS_VIEWS.REF_ACAD.LISTADO_REF_ACAD,
        PERMISSIONS_VIEWS.REF_ACAD.CARGA_MANUAL,
        PERMISSIONS_VIEWS.REF_ACAD.CARGA_MASIVA
    ],
    [USER_ROLES.REF_ACAD_TUTOR]: [
        PERMISSIONS_VIEWS.REF_ACAD.LISTADO_REF_ACAD,
        PERMISSIONS_VIEWS.REF_ACAD.ASISTENCIA,
        // se habilita el permiso de eventos
        PERMISSIONS_VIEWS.EVENTOS.LISTADO_EVENTOS,
        PERMISSIONS_VIEWS.EVENTOS.ASISTENCIA
    ],
    [USER_ROLES.ASESORIAS_COORDINADOR]: [
        PERMISSIONS_VIEWS.ASESORIAS.HORARIOS_ASESORIAS,
        PERMISSIONS_VIEWS.ASESORIAS.CREAR_ASESORIAS
    ],
    [USER_ROLES.ASESORIAS_PSICOLOGO]: [
        PERMISSIONS_VIEWS.ASESORIAS.HORARIOS_ASESORIAS
    ],
    [USER_ROLES.RECURSOS_BIBLIOTECA_COORDINADOR]: [
        PERMISSIONS_VIEWS.RECURSOS.BIBLIOTECA,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_HORARIOS,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_SANCIONES
    ],
    [USER_ROLES.RECURSOS_BIBLIOTECARIO]: [
        PERMISSIONS_VIEWS.RECURSOS.BIBLIOTECA
    ],
    [USER_ROLES.RECURSOS_ESPACIOS_UNIVERSITARIOS_COORDINADOR_GENERAL]: [
        PERMISSIONS_VIEWS.CONFIG.ADMIN_HORARIOS,
        PERMISSIONS_VIEWS.RECURSOS.ESPACIOS_UNIVERSITARIOS,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_SANCIONES,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_ESPACIOS
    ],
    [USER_ROLES.RECURSOS_ESPACIOS_UNIVERSITARIOS_COORDINADOR_CAMPUS]: [
        PERMISSIONS_VIEWS.RECURSOS.ESPACIOS_UNIVERSITARIOS,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_SANCIONES,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_ESPACIOS,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_HORARIOS
    ],
    [USER_ROLES.ASESORIAS_JEFECAMPUS]: [
        PERMISSIONS_VIEWS.ASESORIAS.HORARIOS_ASESORIAS
    ],
    [USER_ROLES.COORDINADOR_EVENTOS_ESPACIOS_UNIVERSITARIOS]: [
        PERMISSIONS_VIEWS.EVENTOS.LISTADO_EVENTOS,
        PERMISSIONS_VIEWS.EVENTOS.CARGA_MANUAL,
        PERMISSIONS_VIEWS.EVENTOS.CARGA_MASIVA,
        PERMISSIONS_VIEWS.RECURSOS.ESPACIOS_UNIVERSITARIOS,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_SANCIONES,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_ESPACIOS,
        PERMISSIONS_VIEWS.CONFIG.ADMIN_HORARIOS
    ]
}
export const CAMPUS_SPACE_IDS_BY_USER_ROLE = {
    [RESOURCE_MODULE_IDS.LIBRARY]: [
        USER_ROLES.RECURSOS_BIBLIOTECARIO,
        USER_ROLES.RECURSOS_BIBLIOTECA_COORDINADOR,
        USER_ROLES.SUPERADMIN
    ],
    [RESOURCE_MODULE_IDS.UNIVERSITY_SPACES]: [
        USER_ROLES.RECURSOS_ESPACIOS_UNIVERSITARIOS_COORDINADOR_GENERAL,
        USER_ROLES.RECURSOS_ESPACIOS_UNIVERSITARIOS_COORDINADOR_CAMPUS,
        USER_ROLES.SUPERADMIN,
        USER_ROLES.COORDINADOR_EVENTOS_ESPACIOS_UNIVERSITARIOS
    ],
    [RESOURCE_MODULE_IDS.OTHERS]: []
};
export const INFO_MODULE_VIEWS = [
    {
        id: MODULE_VIEWS.EVENTOS,
        icon: <EventIcon />,
        path: "eventos"
    },
    {
        id: MODULE_VIEWS.REF_ACAD,
        icon: <PenIcon />,
        path: "ref-acad"
    },
    {
        id: MODULE_VIEWS.ASESORIAS,
        icon: <TimerIcon />,
        path: "asesorias",
    },
    {
        id: MODULE_VIEWS.RECURSOS,
        icon: <PieChartIcon />,
        path: "recursos",
    },
    {
        id: MODULE_VIEWS.CONFIG,
        icon: <SettingIcon />,
        path: "config"
    }
];
export const userHasPermission = (userRole, permission) => {
    const userPermissions = ROLE_BY_PERMISSIONS[userRole];
    return userPermissions.includes(permission);
}
export function isResourceCoordinatorByCampus(userRole) {
    return [
        USER_ROLES.RECURSOS_BIBLIOTECARIO,
        USER_ROLES.RECURSOS_ESPACIOS_UNIVERSITARIOS_COORDINADOR_CAMPUS,
        USER_ROLES.COORDINADOR_EVENTOS_ESPACIOS_UNIVERSITARIOS
    ].includes(userRole);
}